<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/mixins";

  div {
    display: flex;
    justify-content: center;
    align-items: center;

    @include colors.utility_classes();

    &.xs {
      height: utils.in_rem(18px);
      width: utils.in_rem(18px);
      padding: utils.in_rem(3px);
      border-radius: 4px;
    }

    &.small {
      height: utils.in_rem(24px);
      width: utils.in_rem(24px);
      padding: utils.in_rem(6px);
      border-radius: 6px;
    }
    &.medium {
      height: utils.in_rem(34px);
      width: utils.in_rem(34px);
      padding: utils.in_rem(9px);
      border-radius: 8px;
    }
    &.large {
      height: utils.in_rem(44px);
      width: utils.in_rem(44px);
      padding: utils.in_rem(12px);
      border-radius: 9px;
    }
    &.xl {
      height: utils.in_rem(54px);
      width: utils.in_rem(54px);
      padding: utils.in_rem(15px);
      border-radius: 10px;
    }
  }
</style>

<script>
  // Components
  import Icon from "./Icon.svelte";
  import Tooltip from "./Tooltip.svelte";
  // Utils
  import { toUtilityClasses } from "../tokens/utils";

  /** @type {string} */
  let cls = "";
  export { cls as class };

  /** @type {"xs", "small" | "medium" | "large" | "xl"} */
  export let size = "medium";
  export let iconSize = "";
  export let style = "";

  export let backgroundColor = "";
  export let color = "";
  export let textGradient = "";
  export let placement = null;

  export let skeleton = false;
</script>

{#if $$slots.tooltip}
  <Tooltip
    {...placement ? { placement } : {}}
    let:onmouseenter
    let:onmouseleave
    let:onblur
    let:onfocus
  >
    <span slot="tooltip"><slot name="tooltip" /></span>
    <div
      class="{toUtilityClasses({
        backgroundColor,
        color,
      })} {size} "
      class:skeleton
      {style}
      role="button"
      tabindex="0"
      on:mouseenter={onmouseenter}
      on:mouseleave={onmouseleave}
      on:focus={onfocus}
      on:blur={onblur}
    >
      <Icon
        class="{toUtilityClasses({ textGradient })} {cls}"
        size={iconSize || size}
        {skeleton}
      />
    </div>
  </Tooltip>
{:else}
  <div
    class="{toUtilityClasses({ backgroundColor, color })} {size}"
    class:skeleton
    {style}
  >
    <Icon
      class="{toUtilityClasses({ textGradient })} {cls}"
      size={iconSize || size}
      {skeleton}
    />
  </div>
{/if}
